type AttributeConfig = {
  testId?: string | null;
  tourId?: string | null;
};

const TEST_ATTRIBUTE = 'data-test-id';
const TOUR_ATTRIBUTE = 'data-tour-id';

export const getAttributes = ({
  testId = null,
  tourId = null,
}: AttributeConfig) => {
  const attributes: Record<string, string> = {};
  // Добавить гет конфиг в будущем, сейчас нет необходимости
  // const { appStagingMode, siteTourEnabled } = getConfig();
  //
  // if (testId && appStagingMode !== 'production') {
  //   attributes[TEST_ATTRIBUTE] = testId;
  // }

  if (tourId) {
    attributes[TOUR_ATTRIBUTE] = tourId;
  }

  return attributes;
};
